import copy from 'copy-to-clipboard';
import { capitalize } from 'lodash-es';
import type { ReactNode } from 'react';

import EditBusinessUnitButton from '@zen/Accounts/AccountDetails/BusinessUnits/EditBusinessUnitButton';
import { IconButton } from '@zen/DesignSystem';
import type { TableColumn } from '@zen/DesignSystem/types';

import type { BusinessUnitTableItem } from '../types';

export default (canEditBusinessUnit: boolean, showAdminSettings: boolean): TableColumn<BusinessUnitTableItem>[] => {
  const nameColumn: TableColumn<BusinessUnitTableItem> = {
    key: 'tradingName',
    title: 'Business unit',
    resizable: false,
    sortable: true
  };

  const typeColumn: TableColumn<BusinessUnitTableItem> = {
    key: 'type',
    sortable: false,
    alignment: 'left',
    title: 'Type',
    render: (_, { type }: BusinessUnitTableItem): ReactNode => {
      return capitalize(type);
    }
  };

  const actionColumn: TableColumn<BusinessUnitTableItem> = {
    key: 'actions',
    fixed: 'right',
    render: (_, { id, referencePrefix, tradingName }: BusinessUnitTableItem): ReactNode => {
      return (
        <div className="flex space-x-2">
          <IconButton icon="zicon-copy" onClick={() => copy(id)} size="medium" title="Copy business unit ID" variant="ghost" />
          {canEditBusinessUnit && (
            <EditBusinessUnitButton
              id={id}
              name={tradingName}
              referencePrefix={referencePrefix}
              showAdminSettings={showAdminSettings}
            />
          )}
        </div>
      );
    },
    sortable: false
  };

  return [nameColumn, typeColumn, actionColumn];
};
